// extracted by mini-css-extract-plugin
export var container = "_m1-0";
export var dotAnimation = "_m1-2";
export var dotsLoading = "_m1-1";